import { LazyMotion } from "motion/react";
import type { FC, PropsWithChildren } from "react";

const loadFeatures = () => import("./features").then((res) => res.default);

const LazyFramer: FC<PropsWithChildren> = ({ children }) => {
	return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
};

export default LazyFramer;
